import { NgModule } from '@angular/core';
import { LyDeepComponent } from './deep';
import { LyShadowService } from './shadow.service';
var LyShadowModule = /** @class */ (function () {
    function LyShadowModule() {
    }
    LyShadowModule.forRoot = function () {
        return {
            ngModule: LyShadowModule,
            providers: [LyShadowService],
        };
    };
    LyShadowModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [LyDeepComponent],
                    exports: [LyDeepComponent],
                    providers: [LyShadowService]
                },] },
    ];
    /** @nocollapse */
    LyShadowModule.ctorParameters = function () { return []; };
    return LyShadowModule;
}());
export { LyShadowModule };
//# sourceMappingURL=shadow.module.js.map